(() => {
  'use strict';
  const config = document.querySelector('[data-edmt-widget-accessibility]');
  if (!config || !config.dataset.ratingLabel || !config.dataset.coverLabel) return;
  let localizedProducts = {};
  try { localizedProducts = JSON.parse(document.querySelector('[data-edmt-widget-products]')?.textContent || '{}'); } catch { /* Native widgets keep their existing titles if no exact mapping is available. */ }
  const scope = '.jm-review-widget,.jdgm-widget,.jdgm-carousel-wrapper,.cbb-frequently-bought-container,.edmtsend-vault-page,.flickity-page-dots,.waveform,.jukebox-wrapper #playPause.play-pause-btn,.landing_page .shell[aria-label="FREE DOWNLOADS VAULT"]';
  const setLabel = (node, value) => {
    if (value && node.getAttribute('aria-label') !== value) node.setAttribute('aria-label', value);
  };
  const refresh = (root) => {
    if (root.matches('.flickity-page-dots')) {
      for (const dot of root.querySelectorAll('.dot[aria-label]')) {
        const match = /^Page dot (\d+)$/.exec(dot.getAttribute('aria-label'));
        if (match && config.dataset.playerPageDot) setLabel(dot,config.dataset.playerPageDot.replace('__EDMT_NUMBER__',match[1]));
      }
      return;
    }
    if (root.matches('.jukebox-wrapper #playPause.play-pause-btn')) {
      const label = root.getAttribute('aria-label');
      if (label === 'Play previews') setLabel(root, config.dataset.playerPlayPreview);
      if (label === 'Pause previews') setLabel(root, config.dataset.playerPausePreview);
      return;
    }
    if (root.matches('.waveform')) {
      // Generated labels may sit inside presentation wrappers.
      // Match only exact control labels and leave executable content intact.
      const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
      let node;
      while ((node = walker.nextNode())) {
        if (node.parentElement?.closest('script,style,canvas')) continue;
        const text = node.nodeValue || '', label = text.trim();
        const vocal = /^Vocal Preview (\d+)$/.exec(label);
        const localized = label === '808 Preview' ? config.dataset['playerPreview-808']
          : vocal && config.dataset.playerVocalPreview ? config.dataset.playerVocalPreview.replace('__EDMT_NUMBER__',vocal[1]) : '';
        if (localized && localized !== label) node.nodeValue = text.replace(label,localized);
      }
      const label=root.getAttribute('aria-label') || '';
      if (label === '808 Preview') setLabel(root,config.dataset['playerPreview-808']);
      const vocal=/^Vocal Preview (\d+)$/.exec(label);
      if (vocal && config.dataset.playerVocalPreview) setLabel(root,config.dataset.playerVocalPreview.replace('__EDMT_NUMBER__',vocal[1]));
      return;
    }
    if (root.matches('.edmtsend-vault-page,.landing_page .shell')) {
      setLabel(root, config.dataset.vaultLabel);
      return;
    }
    for (const link of root.querySelectorAll('a.jdgm-carousel-item__product,.cbb-frequently-bought-selector-label-name a')) {
      const path = new URL(link.href, location.href).pathname.replace(/^\/[a-z]{2}(?:-[a-z]{2})?(?=\/)/i, '');
      const product = localizedProducts[path];
      const title = link.querySelector('.jdgm-carousel-item__product-title,h3');
      if (!product?.title || !product.url || !title || title.childElementCount) continue;
      if (title.textContent !== product.title) title.textContent = product.title;
      const next = new URL(product.url, location.origin);
      const previous = new URL(link.href, location.href);
      if (!next.search) next.search = previous.search;
      next.hash = previous.hash;
      if (next.origin === location.origin && next.pathname.includes('/products/') && link.href !== next.href) link.href = next.href;
    }
    const navigationLabels = new Map([["Go to previous page","previousPage"],["Go to next page","nextPage"],["Previous reviews","previousReviews"],["Next reviews","nextReviews"]]);
    for (const node of root.querySelectorAll('[aria-label]')) {
      const key = navigationLabels.get(node.getAttribute('aria-label'));
      if (key) setLabel(node, config.dataset[key]);
      if (node.matches('.jm-pagination-controls') && node.getAttribute('aria-label') === 'Pagination Navigation') setLabel(node, config.dataset.paginationNavigation);
      const pageNumber = node.matches('.jm-pagination-controls__button--page') && /^Go to page (\d+)$/.exec(node.getAttribute('aria-label') || '');
      if (pageNumber && config.dataset.goToPage) setLabel(node, config.dataset.goToPage.replace('__EDMT_NUMBER__', pageNumber[1]));
    }
    // Translate only the app's English aggregate label; preserve its live count.
    if (config.dataset.reviewCount) for (const label of root.querySelectorAll('.jdgm-carousel-number-of-reviews')) {
      if (label.childElementCount) continue;
      const match = /^from ([0-9][0-9,.  ]*) reviews$/i.exec(label.textContent.trim());
      if (match) label.textContent = config.dataset.reviewCount.replace('__EDMT_COUNT__', match[1]);
    }
    // Reuse the review app's translated verified badge, preserving its meaning.
    for (const badge of root.querySelectorAll('.jm-verified-badge')) {
      const label = badge.querySelector('p')?.textContent?.trim();
      const icon = badge.querySelector('.jm-with-icon[aria-label]');
      if (label && icon) setLabel(icon, label);
    }
    for (const rating of root.querySelectorAll('.jm-star-rating[aria-label],.jdgm-prev-badge__stars[aria-label],.jdgm-all-reviews-rating[aria-label],.jdgm-carousel-item__review-rating[aria-label]')) {
      const match = /^(\d+(?:\.\d+)?)(?: out of (\d+))? stars$/.exec(rating.getAttribute('aria-label') || '');
      if (!match || Number(match[2] || 5) !== 5 || Number(match[1]) < 0 || Number(match[1]) > 5) continue;
      setLabel(rating, config.dataset.ratingLabel.replace('__EDMT_RATING__', match[1]).replace('__EDMT_MAXIMUM__', match[2] || '5'));
    }
    if (!root.matches('.cbb-frequently-bought-container')) return;
    if (config.dataset.selectionLabel) for (const input of root.querySelectorAll('input[type="checkbox"][aria-label]')) {
      const label = input.getAttribute('aria-label') || '';
      if (label.startsWith('Selection of ')) setLabel(input, config.dataset.selectionLabel.replace('__EDMT_PRODUCT__', label.slice(13)));
    }
    const products = [...root.querySelectorAll('.cbb-frequently-bought-products > .cbb-frequently-bought-product')];
    const labels = [...root.querySelectorAll('.cbb-frequently-bought-selector-label-name')];
    if (products.length !== labels.length || products.length === 0) return;
    products.forEach((product, index) => {
      const name = labels[index].cloneNode(true);
      name.querySelectorAll('.cbb-frequently-bought-this-item-label').forEach(node => node.remove());
      const link = product.querySelector('a[href]');
      const nativePath = link ? new URL(link.href, location.href).pathname.replace(/^\/[a-z]{2}(?:-[a-z]{2})?(?=\/)/i, '') : '';
      const nativeProduct = localizedProducts[nativePath];
      const nameNode = labels[index].querySelector('h3 > span:last-child');
      if (nativeProduct?.title && nameNode && !nameNode.childElementCount && !nameNode.matches('.cbb-frequently-bought-this-item-label')) {
        if (nameNode.textContent !== nativeProduct.title) nameNode.textContent = nativeProduct.title;
      }
      const title = nativeProduct?.title || name.textContent.trim();
      const checkbox = labels[index].closest('li')?.querySelector('input[type="checkbox"]');
      if (title && checkbox && config.dataset.selectionLabel) setLabel(checkbox, config.dataset.selectionLabel.replace('__EDMT_PRODUCT__', title));
      const image = product.querySelector('.cbb-frequently-bought-product-image[aria-label]');
      if (title && image) setLabel(image, config.dataset.coverLabel.replace('__EDMT_PRODUCT__', title));
    });
  };
  const pending = new Set();
  let queued = false;
  const enqueue = (node) => {
    const element = node.nodeType === Node.ELEMENT_NODE ? node : node.parentElement;
    if (!element) return;
    const owner = element.closest(scope);
    if (owner) pending.add(owner);
    else element.querySelectorAll(scope).forEach(root => pending.add(root));
    if (!pending.size || queued) return;
    queued = true;
    requestAnimationFrame(() => {
      queued = false;
      const roots = [...pending]; pending.clear();
      roots.filter(root => root.isConnected).forEach(refresh);
    });
  };
  document.querySelectorAll(scope).forEach(refresh);
  new MutationObserver(records => {
    for (const record of records) {
      if (record.type === 'attributes' || record.type === 'characterData') enqueue(record.target);
      else record.addedNodes.forEach(enqueue);
    }
  }).observe(document.body, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['aria-label'] });
})();
